import React from 'react';

const ResultsPage: React.FC = () => {
  return <div>Results Page - Coming Soon</div>;
};

export default ResultsPage; 